import { render, staticRenderFns } from "./ReceiverLocationListPage.vue?vue&type=template&id=47a5f45c&scoped=true&"
import script from "./ReceiverLocationListPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverLocationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5f45c",
  null
  
)

export default component.exports